import { MergePersonaModalSubmitter } from '../../lib/merge-persona-modal/merge-persona-modal-submit.service'
import { DocsMergePersonaModalSubmitter } from './docs-merge-persona-modal-submitter.service'

export const PROVIDERS = [
  {
    provide: MergePersonaModalSubmitter,
    useClass: DocsMergePersonaModalSubmitter,
  }
]
